import { api } from './api';

export interface FilterCondition {
  field: 'from_contains' | 'to_contains' | 'subject_contains' | 'body_contains' | 'has_attachment';
  operator: 'contains' | 'not_contains' | 'equals' | 'is_true';
  value: string;
}

export interface FilterAction {
  type: 'apply_label' | 'mark_read' | 'archive' | 'add_follow_up' | 'add_billing_opp' | 'link_to_matter';
  value?: string;
}

export interface FilterRule {
  id: string;
  name: string;
  conditionLogic: 'all' | 'any';
  conditions: FilterCondition[];
  actions: FilterAction[];
  stopProcessing: boolean;
  enabled: boolean;
  hitCount: number;
  createdAt: string;
  updatedAt?: string;
}

export async function fetchFilters(): Promise<FilterRule[]> {
  const res = await api.get('/inbox/filters');
  return res.data.rules;
}

export async function createFilter(
  input: Omit<FilterRule, 'id' | 'hitCount' | 'createdAt' | 'updatedAt'>,
): Promise<FilterRule> {
  const res = await api.post('/inbox/filters', input);
  return res.data;
}

export async function updateFilter(
  filterId: string,
  input: Partial<Omit<FilterRule, 'id' | 'hitCount' | 'createdAt'>>,
): Promise<FilterRule> {
  const res = await api.patch(`/inbox/filters/${filterId}`, input);
  return res.data;
}

export async function deleteFilter(filterId: string): Promise<void> {
  await api.delete(`/inbox/filters/${filterId}`);
}
